import React from 'react';
import { useTranslation } from 'react-i18next';

import dayjs from 'shared/helpers/dayjs';
import { NoteRevision } from 'shiftNotes/_types';
import formatRevisionEditorLabel from 'events/helpers/versionHistoryFormat';

import * as Styled from 'events/styles/EventVersionRevisionCard.style';

interface EventVersionRevisionCardProps {
  revision: NoteRevision;
  noteAuthorName: string;
  isNoteCreation: boolean;
  isCurrentUser: boolean;
  noteId: string;
}

export default function EventVersionRevisionCard({
  revision,
  noteAuthorName,
  isNoteCreation,
  isCurrentUser,
  noteId,
}: EventVersionRevisionCardProps): JSX.Element {
  const { t } = useTranslation('pageEvents');

  const revisionDate = dayjs(revision.created);
  const format =
    revisionDate.year() !== dayjs().year()
      ? 'MMM D, YYYY, h:mm A'
      : 'MMM D, h:mm A';

  const editorLabel = formatRevisionEditorLabel({
    t,
    revision,
    noteAuthorName,
    isNoteCreation,
    isCurrentUser,
  });

  return (
    <Styled.Item
      data-testid={`event-version-revision-${noteId}-${revision.created}`}
    >
      <Styled.LabelGroup>
        <Styled.DateTimeLabel>
          {revisionDate.format(format)}
        </Styled.DateTimeLabel>
        <Styled.EditorLabel>{editorLabel}</Styled.EditorLabel>
      </Styled.LabelGroup>
      <Styled.Card>
        <Styled.RevisionBody>{revision.text}</Styled.RevisionBody>
      </Styled.Card>
    </Styled.Item>
  );
}
